import { render, staticRenderFns } from "./BaseModalCenter.vue?vue&type=template&id=b83a5bf8&"
import script from "./BaseModalCenter.vue?vue&type=script&lang=js&"
export * from "./BaseModalCenter.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalCenter.vue?vue&type=style&index=0&id=b83a5bf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports